var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPassword4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2072",
    "data-name": "Rectangle 2072",
    width: 161.333,
    height: 173.143,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2376",
    "data-name": "Groupe 2376",
    transform: "translate(-832 -275)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_313",
    "data-name": "Ellipse 313",
    cx: 128,
    cy: 128,
    r: 128,
    transform: "translate(832 275)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2381",
    "data-name": "Groupe 2381",
    transform: "translate(892.837 316.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2377",
    "data-name": "Groupe 2377",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2918",
    "data-name": "Trac\\xE9 2918",
    d: "M12.661,62.9H25.93A3.27,3.27,0,0,0,29.2,59.624V46.039a26.293,26.293,0,0,1,52.586,0V59.624A3.26,3.26,0,0,0,85.064,62.9H98.317a3.257,3.257,0,0,0,3.211-3.274V46.039a44.666,44.666,0,0,0-1.091-9.932A46.033,46.033,0,0,0,9.45,46.039V59.624A3.268,3.268,0,0,0,12.661,62.9",
    transform: "translate(5.496 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2919",
    "data-name": "Trac\\xE9 2919",
    d: "M108.826,43.937H13.158A13.145,13.145,0,0,0,0,57.08v58.9a13.158,13.158,0,0,0,13.158,13.158h75.5a41.195,41.195,0,0,1,33.323-57.378V57.08a13.155,13.155,0,0,0-13.158-13.143M68.671,88.916v16.116a7.678,7.678,0,1,1-15.357,0V88.916a15.923,15.923,0,0,1-.569-27.582h.016a15.922,15.922,0,0,1,16.464,0h.016a15.923,15.923,0,0,1-.569,27.582",
    transform: "translate(0 25.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2920",
    "data-name": "Trac\\xE9 2920",
    d: "M127.662,100.25A34.881,34.881,0,1,1,88.313,65.662a34.451,34.451,0,0,1,4.46-.285,34.923,34.923,0,0,1,34.889,34.873",
    transform: "translate(33.671 38.02)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2921",
    "data-name": "Trac\\xE9 2921",
    d: "M87.459,102.594H81.1V99.165a7.98,7.98,0,0,1,.535-3.348,12.4,12.4,0,0,1,2.333-2.9l4.107-4.1a4.963,4.963,0,0,0,1.292-3.489,4.745,4.745,0,0,0-1.349-3.459,4.669,4.669,0,0,0-3.486-1.378,5.075,5.075,0,0,0-3.573,1.322A5.336,5.336,0,0,0,79.3,85.328H72.5a11.513,11.513,0,0,1,3.908-7.844,12.448,12.448,0,0,1,8.351-2.84,12.014,12.014,0,0,1,8.156,2.727,9.546,9.546,0,0,1,3.15,7.621,8.547,8.547,0,0,1-1.857,5.624,24.811,24.811,0,0,1-1.631,1.912q-.562.565-1.491,1.433t-1.575,1.52c-.43.432-.778.8-1.039,1.1a5.363,5.363,0,0,0-1.014,3.486ZM84.4,115.08a4.332,4.332,0,0,1-3.065-1.21,3.852,3.852,0,0,1-1.3-2.923,3.987,3.987,0,0,1,1.267-2.953,4.185,4.185,0,0,1,3.037-1.238,4.337,4.337,0,0,1,3.065,1.21A3.86,3.86,0,0,1,88.7,110.89a3.99,3.99,0,0,1-1.265,2.953A4.193,4.193,0,0,1,84.4,115.08",
    transform: "translate(42.162 43.408)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword4);
export default __webpack_public_path__ + "static/media/resetPassword4.9b904023b812d2c04c6d111c1cbe987f.svg";
export { ForwardRef as ReactComponent };